import {metadaApi} from '@dms/api/base';

import {
  PostMarketingCodeRequest,
  PostMarketingCodeRequestSchema,
  PostMarketingCodeResponse,
  PostMarketingCodeResponseSchema,
  GetMarketingCodeRequest,
  GetMarketingCodeRequestSchema,
  GetMarketingCodeResponse,
  GetMarketingCodeResponseSchema,
  GetMarketingCodesRequest,
  GetMarketingCodesRequestSchema,
  GetMarketingCodesResponse,
  GetMarketingCodesResponseSchema,
  PatchMarketingCodeRequest,
  PatchMarketingCodeRequestSchema,
  PatchMarketingCodeResponse,
  PatchMarketingCodeResponseSchema,
} from './types';

export const metadaWarehouseMarketingCodeApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getMarketingCodes: build.query<GetMarketingCodesResponse, GetMarketingCodesRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/marketing-codes`,
        method: 'GET',
        queryArg,
      }),
      providesTags: ['marketingCode'],
      extraOptions: {
        requestSchema: GetMarketingCodesRequestSchema,
        responseSchema: GetMarketingCodesResponseSchema,
      },
    }),
    getMarketingCode: build.query<GetMarketingCodeResponse, GetMarketingCodeRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/marketing-code/${queryArg.marketingCodeId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: ['marketingCode'],
      extraOptions: {
        requestSchema: GetMarketingCodeRequestSchema,
        responseSchema: GetMarketingCodeResponseSchema,
      },
    }),
    postMarketingCode: build.mutation<PostMarketingCodeResponse, PostMarketingCodeRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/marketing-code`,
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: ['marketingCode'],
      extraOptions: {
        requestSchema: PostMarketingCodeRequestSchema,
        responseSchema: PostMarketingCodeResponseSchema,
      },
    }),
    patchMarketingCode: build.mutation<PatchMarketingCodeResponse, PatchMarketingCodeRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/marketing-code/${queryArg.marketingCodeId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['marketingCode'],
      extraOptions: {
        requestSchema: PatchMarketingCodeRequestSchema,
        responseSchema: PatchMarketingCodeResponseSchema,
      },
    }),
  }),
});

export const {
  useGetMarketingCodesQuery,
  useGetMarketingCodeQuery,
  usePostMarketingCodeMutation,
  usePatchMarketingCodeMutation,
} = metadaWarehouseMarketingCodeApi;
